import { DatePickerInput } from '@delmonicos/shared-design-system-react/src/components/date-picker-input/date-picker-input';
import {
  ModeEnum,
  coerceDatePickerRangeRequiredSelection,
} from '@delmonicos/shared-design-system-react/src/components/date-picker/date-picker';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import {
  Text,
  TextColor,
  TextFontSize,
} from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { useGatewayGetTransactionsExportFormValidation } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/transactions/models/inputs/gateway-get-transactions-export.form-validation';
import { GatewayGetTransactionsExportModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/transactions/models/inputs/gateway-get-transactions-export.model';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

const TransactionListExportFormStep1DateRangeFragment =
  (): React.JSX.Element => {
    // CONTEXT /////////////////////////////////////////////////////////////////

    const { t } = useTranslation();
    const { control } = useFormContext<GatewayGetTransactionsExportModel>();
    const { createdAfter, createdBefore } =
      useGatewayGetTransactionsExportFormValidation();

    // RENDER ////////////////////////////////////////////////////////////////////

    return (
      <Stack gap={GapEnum.L} flex={1} direction="column">
        <Controller
          name="createdAfter"
          control={control}
          rules={createdAfter}
          render={({
            field: fieldCreatedAfter,
            fieldState: { error: errorCreatedAfter },
          }) => {
            return (
              <Controller
                name="createdBefore"
                control={control}
                rules={createdBefore}
                render={({
                  field: fieldCreatedBefore,
                  fieldState: { error: errorCreatedBefore },
                }) => {
                  return (
                    <Stack gap={GapEnum.XS} direction="column">
                      <Text fontSize={TextFontSize.Small} uppercase>
                        {t(
                          'delmonicos-shared-sdk.inputs-gateway-get-transactions-export.created-after',
                        )}{' '}
                        /{' '}
                        {t(
                          'delmonicos-shared-sdk.inputs-gateway-get-transactions-export.created-before',
                        )}
                      </Text>
                      <DatePickerInput
                        required
                        mode={ModeEnum.Range}
                        selected={{
                          from: fieldCreatedAfter.value
                            ? new Date(fieldCreatedAfter.value)
                            : undefined,
                          to: fieldCreatedBefore.value
                            ? new Date(fieldCreatedBefore.value)
                            : undefined,
                        }}
                        onSelect={(...args) => {
                          const { from, to } =
                            coerceDatePickerRangeRequiredSelection(...args);

                          fieldCreatedAfter.onChange(from ?? '');
                          fieldCreatedBefore.onChange(to ?? '');
                        }}
                      />
                      {(errorCreatedAfter?.message ||
                        errorCreatedBefore?.message) && (
                        <Text color={TextColor.Error}>
                          {errorCreatedAfter?.message}
                          {errorCreatedBefore?.message}
                        </Text>
                      )}
                    </Stack>
                  );
                }}
              />
            );
          }}
        />
      </Stack>
    );
  };

export const TransactionListExportFormStep1Controller =
  (): React.JSX.Element => {
    // RENDER //////////////////////////////////////////////////////////////////

    return (
      <Stack
        direction="row"
        justifyContent="stretch"
        alignItems="stretch"
        flex={1}
        gap={GapEnum.XL}>
        <Stack
          direction="column"
          flex={1}
          alignItems="stretch"
          gap={GapEnum.XL}>
          <TransactionListExportFormStep1DateRangeFragment />
        </Stack>
      </Stack>
    );
  };
